<template>
  <v-card>
    <v-card-title style="justify-content: center;">{{ $t('pickingForm.title') }}</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 1500px;">
      <validation-observer ref="form">
        <v-form @submit.prevent="onSubmit" id="pickingForm">
          <v-col cols="12">
            <v-checkbox
                v-model="pickingForm.preFill"
                :label="$t('pickingForm.preFillWithDeliveryAddress')"
                @change="preFillForm"
            ></v-checkbox>
            <span class="text-caption font-weight-thin">* {{ $t('pickingForm.requiredFields') }}</span>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.pickingDate')" rules="required">
              <v-datetime-picker
                  v-model="pickingForm.requested_picking_date"
                  :clear-text="$t('pickingForm.clearTextDate')"
                  :date-picker-props="{locale: locale}"
                  :label="$t('pickingForm.pickingDate') + '*'"
                  :text-field-props="{errorMessages: errors }"
                  :time-picker-props="{format: '24hr', min:settings.pickup_hours.begin, max:settings.pickup_hours.end}"
                  class="mt-2"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock-outline</v-icon>
                </template>
              </v-datetime-picker>
            </validation-provider>
              <v-select
                  v-if="settingsFormFields &&  settingsFormFields.civility"
                  v-model="pickingForm.civility"
                  :items="civilityItems"
                  :label="$t('pickingForm.civility')"
                  class="mt-4"
                  dense
              ></v-select>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.firstName')" rules="required">
              <v-text-field
                  v-model="pickingForm.first_name"
                  :error-messages="errors"
                  :label="$t('pickingForm.firstName')"
                  class="required"
                  clearable
                  required
              >
              </v-text-field>
            </validation-provider>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.lastName')" rules="required">
              <v-text-field
                  v-model="pickingForm.last_name"
                  :error-messages="errors"
                  :label="$t('pickingForm.lastName')"
                  class="required"
                  clearable
                  required
              >
              </v-text-field>
            </validation-provider>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.street1')" rules="required">
              <v-text-field
                  v-model="pickingForm.street_1"
                  :error-messages="errors"
                  :label="$t('pickingForm.street1')"
                  class="required"
                  clearable
                  required
              >
              </v-text-field>
            </validation-provider>
              <v-text-field
                  v-if="settingsFormFields && settingsFormFields.street_2"
                  v-model="pickingForm.street_2"
                  :label="$t('pickingForm.street2')"
                  clearable
              >
              </v-text-field>
              <v-text-field
                  v-if="settingsFormFields && settingsFormFields.street_3"
                  v-model="pickingForm.street_3"
                  :label="$t('pickingForm.street3')"
                  clearable
              >
              </v-text-field>
              <v-text-field
                  v-model="pickingForm.postal_code"
                  :label="$t('pickingForm.postalCode')"
                  clearable
                  required
              >
              </v-text-field>
            <v-text-field
                v-if="settingsFormFields && settingsFormFields.company"
                v-model="pickingForm.company"
                :label="$t('pickingForm.company')"
                clearable
            >
            </v-text-field>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.city')" rules="required">
              <v-text-field
                  v-model="pickingForm.city"
                  :error-messages="errors"
                  :label="$t('pickingForm.city')"
                  class="required"
                  clearable
                  required
              >
              </v-text-field>
            </validation-provider>
              <v-text-field
                  v-if="settingsFormFields && settingsFormFields.region"
                  v-model="pickingForm.region"
                  :label="$t('pickingForm.region')"
                  clearable
              >
              </v-text-field>
            <validation-provider v-slot="{ errors }" :name="$t('pickingForm.countryCode')" rules="required">
              <CountriesAutocomplete v-model="pickingForm.country_code" :errorMessage="errors" :required="true" item-text="name" />
            </validation-provider>
              <v-text-field
                  v-if="settingsFormFields && settingsFormFields.district"
                  v-model="pickingForm.district"
                  :label="$t('pickingForm.district')"
                  clearable
              >
              </v-text-field>
            <vue-tel-input-vuetify
                v-if="settingsFormFields && settingsFormFields.phone"
                id="phone_input"
                v-model="pickingForm.phone"
                :error-messages="phoneError"
                :placeholder="$t('pickingForm.phone')"
                class="mt-1"
                label=""
                mode="international"
                @input="updatePhone"
            />
            <vue-tel-input-vuetify
                v-if="settingsFormFields && settingsFormFields.cell_phone"
                id="phone_cell"
                v-model="pickingForm.cell_phone"
                :error-messages="phoneCellError"
                :placeholder="$t('pickingForm.cellPhone')"
                class="mt-1"
                label=""
                mode="international"
                @input="updateCellPhone"
            />
            <v-checkbox
                v-model="pickingForm.charge_return_fees"
                :label="$t('pickingForm.customerReturnPaid')"
            />
          </v-col>
        </v-form>
      </validation-observer>
    </v-card-text>
    <v-card-actions class="pa-0 mt-2">
      <v-btn
          color="primary"
          style="width: 50%"
          tile
          type="submit"
          form="pickingForm">
        {{ $t('pickingForm.validate') }}
      </v-btn>
      <v-btn
          class="ml-0"
          color="secondary"
          style="width: 50%"
          tile
          @click="close()">
        {{ $t('pickingForm.cancel') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState } from 'vuex'
import moment from 'moment'
import CountriesAutocomplete from "@/components/CountriesAutocomplete"

export default {
  name: 'PickingForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    CountriesAutocomplete
  },
  props: {
    preFillCheckbox: {
      type: Boolean,
      required: true,
    },
    shippingAddress: {
      type: Object,
    },
    pickingAddress: {
      type: Object,
    },
    settings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      locale: moment.locale(),
      pickingForm: {
        civility: '',
        first_name: '',
        last_name: '',
        street_1: '',
        street_2: '',
        street_3: '',
        company: '',
        postal_code: '',
        city: '',
        region: '',
        district: '',
        country_code: '',
        phone: '',
        cell_phone: '',
        requested_picking_date: '',
        preFill: false,
        charge_return_fees: true
      },
      phoneError: [],
      phoneCellError: [],
      settingsFormFields: null
    }
  },
  mounted () {
    if (this.pickingAddress) {
      this.pickingForm = this.pickingAddress
    }
    this.settingsFormFields = this.settings.optional_form_fields
  },
  computed: {
    ...mapState(['currentGroup']),
    civilityItems () {
      return [
        { text: this.$t('pickingForm.mr'), value: 'mr' },
        { text: this.$t('pickingForm.mrs'), value: 'mrs' },
      ]
    },
  },
  methods: {
    async onSubmit () {
      const success = await this.$refs.form.validate()
      if (success) {
        this.pickingForm.company = this.currentGroup.name
        if(this.pickingForm.postal_code === ""){
          this.pickingForm.postal_code = "00000"
        }
        let formData = this.removeEmptyValue(this.pickingForm)
        this.$emit('validateForm', formData)
      }
    },
    close () {
      this.$emit('close')
    },
    preFillForm (newValue) {
      if (newValue) {
        this.pickingForm.city = this.shippingAddress.city
        this.pickingForm.street_1 = this.shippingAddress.street_1
        this.pickingForm.street_2 = this.shippingAddress.street_2
        this.pickingForm.street_3 = this.shippingAddress.street_3
        this.pickingForm.first_name = this.shippingAddress.first_name
        this.pickingForm.last_name = this.shippingAddress.last_name
        this.pickingForm.postal_code = this.shippingAddress.postal_code
      } else {
        for (let key of Object.keys(this.pickingForm)) {
          console.log(this.pickingForm[key] )
          this.pickingForm[key] = ''
        }
        console.log(this.pickingForm)
        this.$refs.form.reset()
      }
    },
    removeEmptyValue (form) {
      let newFormObject = {}
      for (let key of Object.keys(form)) {
        if (form[key] !== '') {
          newFormObject[key] = form[key]
        }
      }
      return newFormObject
    },
    updatePhone (number, phone) {
      this.validatePhone(number, phone, 'updatePhone')
    },
     updateCellPhone (number, phone) {
      this.validatePhone(number, phone, 'updateCellPhone')
    },
    validatePhone (number, phone, errorVar) {
      if (phone.isValid) {
        if (errorVar === 'updateCellPhone') {
          this.phoneCellError = []
          this.pickingForm.cell_phone = phone.number.e164
        } else {
          this.phoneError = []
          this.pickingForm.phone = phone.number.e164
        }
      } else {
        if (errorVar === 'updateCellPhone') {
          this.phoneCellError = this.$t('pickingForm.cellPhoneError')
        } else {
          this.phoneError = this.$t('pickingForm.phoneError')
        }
      }
    },
  },
}
</script>

<style>
.required label::after {
  content: "*";
}
</style>
